/**
 * The embed's own legacy paths, the ones the shared redirect table does not know about.
 *
 * `LEGACY_PRODUCT_REDIRECTS` in `@hopdrive/feature-portal-products` covers the paths the dealer
 * and the embed shared (`/valet/*`, `/dashboard`, `/plan-moves`, `/parts-delivery/queue`, …);
 * `/moves` is a real route, the Moves product root. `/parts-delivery/runs` was only
 * ever an embed path — the placeholder `PartsDeliveryRunsPage` the shell's **Active Runs** tab
 * replaces — so an integrator's bookmark to it has no shared entry to land on. Keep it here rather
 * than widen the package with a route the dealer never had (decision S11).
 */
export interface EmbedLegacyRedirect {
  from: string;
  to: string;
}

export const EMBED_LEGACY_REDIRECTS: EmbedLegacyRedirect[] = [
  { from: '/parts-delivery/runs', to: '/parts-delivery/live' },
];
